export default {
    List: [
        {
            TypeId: 10,
            TypeCode: 'Text',
            TypeName: "Chữ"
        },{
            TypeId: 35,
            TypeCode: 'List',
            TypeName: "Danh sách"
        },{
            TypeId: 25,
            TypeCode: 'Number',
            TypeName: "Số"
        },{
            TypeId: 5,
            TypeCode: 'Currency',
            TypeName: "Số tiền"
        },{
            TypeId: 30,
            TypeCode: 'Ratio',
            TypeName: "Tỷ lệ"
        },{
            TypeId: 15,
            TypeCode: 'Date',
            TypeName: "Ngày tháng"
        },{
            TypeId: 20,
            TypeCode: 'Boolean',
            TypeName: "Đúng/Sai"
        },{
            TypeId: 40,
            TypeCode: 'Constant',
            TypeName: "Hệ số"
        },],

    Enum:{
        Text: 'Chữ',
        List: 'Danh sách',
        Number: 'Số',
        Currency: 'Số tiền',
        Constant: 'Hệ số',
        Ratio: 'Tỷ lệ',
        Date: 'Ngày tháng',
        Boolean: 'Đúng/Sai',
        Constant: 'Hệ số',
    },

    DataType: {
        Text: 10,
        List: 35,
        Number: 25,
        Currency: 5,
        Ratio: 30,
        Date: 15,
        Boolean: 20,
        Constant: 40,
    },
    DefaultType: {
        Constant: 5,
        Conditions: 10,
        Formula: 15
    },
    ConditionFieldFixed: {
        DefaultValue: 'DefaultValue',
        DefaultFilter: 'DefaultFilter',
        IsEdit: 'IsEdit',
    },
};